export enum ExportFileTypeEnum {
    CSV = 'CSV'
}
